import styled from 'styled-components';

export const StyledContainer = styled.div`
  #components-layout-demo-side .logo {
    height: 32px;
    margin: 16px;
    background: rgba(255, 255, 255, 0.3);
  }

  .site-layout .site-layout-background {
    background: #fff;
  }
  .header {
    height: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;

    button {
      margin-right: 20px;
    }
  }

  .top-box {
    > div:first-child {
      display: flex;
      align-items: center;
      margin-bottom: 10px;

      > span:first-child {
        width: 25px;
        display: flex;
        height: 25px;
        justify-content: flex-start;
        align-items: center;
      }
    }

    .action-box {
      display: flex;
      justify-content: space-between;
    }
  }
`;
